import { Axios } from 'utils/AxiosConfig'

export const postSubmitSellCompanyForm = async (payload) => {
  const { data: response } = await Axios.post(`member/package-subscription/seller`, payload)
  return response
}
export const getWantedCompanies = async (payload) => {
  const { data: response } = await Axios.get(`public/filter/buyer-profile`, payload)
  return response
}
export const getDetailSellerForm = async (id) => {
  const { data: response } = await Axios.get(`member/package-subscription/seller/${id}`)
  return response
}
export const getWantedCompaniyDetail = async (id) => {
  const { data: response } = await Axios.get(`public/filter/buyer-profile/${id}`)
  return response
}
export const getDetailWantedCompany = async (id) => {
  const { data: response } = await Axios.get(`member/package-subscription/buyer/${id}`)
  return response
}
export const postWantedCompany = async (payload) => {
  const { data: response } = await Axios.post(`member/package-subscription/buyer`, payload)
  return response
}
export const putWantedCompany = async (payload) => {
  const { data: response } = await Axios.put(`member/package-subscription/buyer/${payload.id}`, payload.body)
  return response
}
export const postFavoriteWantedCompanies = async (payload) => {
  const { data: response } = await Axios.post(`member/favorite/buyer-profile`, payload)
  return response
}
export const postAdvisorCompanyForSale = async (payload) => {
  const { data: response } = await Axios.post(`member/profile/advisor/company-for-sale`, payload)
  return response
}
export const postAdvisorWantedCompany = async (payload) => {
  const { data: response } = await Axios.post(`member/profile/advisor/wanted-company`, payload)
  return response
}
export const putAdvisorWantedCompany = async (payload) => {
  const { data: response } = await Axios.put(`member/profile/advisor/wanted-company/${payload.id}`, payload.body)
  return response
}
export const putSubmitSellCompanyForm = async (id, payload) => {
  const { data: response } = await Axios.put(`member/package-subscription/seller/${id}`, payload)
  return response
}
export const putAdvisorSubmitSellCompanyForm = async (id, payload) => {
  const { data: response } = await Axios.put(
    `member/profile/advisor/company-for-sale/${id}`,
    payload
  )
  return response
}
export const putAdvisorCompanyForSale = async (id, payload) => {
  const { data: response } = await Axios.post(
    `member/profile/advisor/company-for-sale/${id}`,
    payload
  )
  return response
}
export const getBuyerListForSold = async (id) => {
  const { data: response } = await Axios.get(`member/profile/company-for-sale/get-contact/${id}`)
  return response
}
export const putListingAsSold = async (payload) => {
  const { data: response } = await Axios.put(`member/profile/company-for-sale/sold/${payload.id}`, payload.body)
  return response
}
export const getDetailProfile = async (id) => {
  const { data: response } = await Axios.get(`member/message/detail-profile/${id}`)
  return response
}